// AI-ASSISTED: generated with claude-code on 2026-06-03, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { EmptyState } from './EmptyState';
export { TileBoundary } from './TileBoundary';
export { ComponentTile } from './ComponentTile';
export { TeamLanding } from './TeamLanding';

const teamLandingContent = EntityContentBlueprint.make({
  name: 'team-landing',
  params: {
    path: '/team-landing',
    title: 'Team landing',
    filter: 'kind:group,spec.type:team',
    loader: async () => {
      const { TeamLanding } = await import('./TeamLanding');
      return <TeamLanding />;
    },
  },
});

export const teamLandingModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [teamLandingContent],
});
